/*
 * Copyright (c) 2021. American Express Company
 */

export enum FauxMenuShape {
    DEFAULT,
    ROUNDED
}

export enum FauxMenuSize {
    DEFAULT,
    MINI
}

export class FauxMenuViewModel {
    disabled?: boolean;
    onClick?: (e: any) => any;
    shape: FauxMenuShape;
    size: FauxMenuSize;
    fullWidth?: boolean;
    className?: string;
    id?: string;
}

export class BasicFauxMenuViewModel {
    disabled?: boolean;
    onClick?: (e: any) => any;
    fullWidth?: boolean;
    className?: string;
    id?: string;
}
